export default {
  SET_ITEMS_SEARCH_HISTORY: 'feedSearch/SET_ITEMS_SEARCH_HISTORY',
  REMOVE_ITEM_SEARCH_TERM: 'feedSearch/REMOVE_ITEM_SEARCH_TERM',

  SET_WISHES_SEARCH_HISTORY: 'feedSearch/SET_WISHES_SEARCH_HISTORY',
  REMOVE_WISH_SEARCH_TERM: 'feedSearch/REMOVE_WISH_SEARCH_TERM',
};
